// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__gWCPm","mainContainer":"MainLayout_mainContainer__vJbDI","mainContent":"MainLayout_mainContent__PxY5x"};